module.exports = __webpack_public_path__ + "static/media/fota_failed.68f2ce0d.png";